<template>
    <div class="page">
        <div class="row gradient-background">
            <div class="wrapper wrapper--no-max-width">
                <header class="row__header">
                    <back-button
                        :isAbsolute="false"
                        :isBlack="true"
                        :isHiddenOnDesktop="true"
                    />
                    <h1>{{ $t('profile.advancedTrading') }}</h1>
                </header>
                <section v-for="section in sections"
                    :key="section.title"
                    class="section"
                >
                    <h2 class="section__title">{{ $t(section.title) }}</h2>
                    <div class="section__content">
                        <div class="section__content--links">
                            <template v-for="(item, index) in section.elements">
                                <div v-if="item.isChzExchangeAppLink"
                                    :key="index"
                                    class="section-link"
                                >
                                    <span class="download-app__text">{{ $t('profile.chzExchangeDownload') }}</span>
                                    <a :href="appStoreLink"
                                        target="_blank"
                                    >
                                        <img :src="require(`@webapp/assets/download-app-store.svg`)"
                                            alt="Download from AppStore"
                                            class="download-app__logo download-app__logo--small"
                                        >
                                    </a>

                                    <a :href="googlePlayLink"
                                        target="_blank"
                                    >
                                        <img :src="require(`@webapp/assets/download-google-play.svg`)"
                                            alt="Download from Google Play"
                                            class="download-app__logo download-app__logo--small"
                                        >
                                    </a>
                                </div>

                                <a v-else-if="item.isExternal"
                                    :key="index"
                                    class="section-link"
                                    :href="item.link"
                                    target="_blank"
                                >
                                    {{ $t(item.text) }}
                                </a>

                                <router-link v-else
                                    :key="index"
                                    class="section-link"
                                    :to="item.link"
                                >
                                    {{ $t(item.text) }}
                                </router-link>
                            </template>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
// Socios Variables
import socios from '@webapp/socios.json';

// Components
import backButton from '@webapp/components/back-button/back-button.vue';


export default {
    name: 'advanced-trading',
    components: {
        backButton,
    },
    data() {
        return {
            sections: [
                {
                    title: 'profile.trading',
                    elements: [
                        {
                            text: 'profile.advancedTradingInfo',
                            link: socios.poaBlockchainExplorer,
                            isExternal: true,
                        },
                        {
                            isChzExchangeAppLink: true,
                        },
                    ],
                },
            ],
            appStoreLink: 'https://apps.apple.com/us/app/id1493980225',
            googlePlayLink: 'https://play.google.com/store/apps/details?id=net.chiliz.broker.android',
        };
    },
};
</script>

<style lang="scss" scoped>
.page {
    color: $cyprus-color;

    .section {
        padding: 2rem;
        max-width: 60%;

        &__title {
            font-weight: bold;
            font-size: 2rem;
            line-height: 3rem;
            color: $daintree-color;
            margin: 1rem 0;
        }

        &__content {
            &--links {
                background-color: $white-color;
                border-radius: 1rem;
                display: grid;
                grid-auto-flow: row;

                .section-link {
                    text-decoration: none;
                    color: $cyprus-color;
                    font-family: "Nunito";
                    padding: 3.5rem;
                    font-size: 1.8rem;
                    line-height: 2.5rem;

                    &:not(:last-child) {
                        border-bottom: solid 1px $mercury-color;
                    }

                    &:hover {
                        color: $black-color;
                    }
                }
            }
        }
    }
}

.download-app {
    &__text {
        vertical-align: middle;
        margin-right: 2rem;
    }

    &__logo {
        display: inline-block;
        margin: 0 0.5rem;
        vertical-align: middle;
        cursor: pointer;

        &--small {
            height: 40px;
        }
    }
}
</style>